import React from 'react'
import useTicketSearch from './hooks/useTicketSearch'
import { Tag } from '@blueprintjs/core'
import { SearchDropdown } from '@ui'
import { getTicketStatus } from './StatusSelect'
import track from '@track'
import Event from '@track/Event'
import { NavigateFn } from '@reach/router'
import { TicketSearchResult } from '@api'

interface TicketSearchProps {
  navigate: NavigateFn
  queryTable: (query: string) => void
}

export default function TicketSearch({ navigate, queryTable }: TicketSearchProps) {
  const search = useTicketSearch()

  function onSelect(item: any) {
    track.tickets({ eventName: Event.SEARCH_RESULT_CLICK })
    navigate(`/tickets?ticketId=${item.id}`)
  }

  return (
    <SearchDropdown
      {...{
        'data-input': 'ticket_search',
        search,
        queryTable,
        onSelect,
        width: '400px',
      }}
      renderItem={(ticket) => <Ticket {...{ ticket }} />}
    />
  )
}

const Ticket = ({ ticket }: { ticket: TicketSearchResult }) => {
  const status = getTicketStatus(ticket.status)
  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginBottom: 3 }}>
        <span style={{ fontSize: 15, fontWeight: 'bolder' }}>
          {ticket.shortDescription}
          <span style={{ marginLeft: 5, color: '#777' }}>{ticket.ticketNumber}</span>
        </span>
      </div>
      <span style={{ color: '#777' }}>
        {ticket.assignedTo ? `Assigned to ${ticket.assignedTo.name}` : 'Unassigned'}
      </span>
      <Tag minimal round style={{ marginLeft: 8 }}>
        {status.value}
      </Tag>
    </div>
  )
}
